(function () {
  'use strict';
  const root = document.documentElement;
  const suppressNewsletter = () => {
    if (!root.classList.contains('pb-purchase-flow')) return;
    const popup = document.getElementById('theMarketer-popup-backdrop');
    const close = popup?.querySelector('button.mkt-popup-close');
    if (close && !popup.dataset.pbDismissed) {
      popup.dataset.pbDismissed = 'true';
      close.click(); // Let the provider restore focus and scroll state.
    }
  };
  const purchase = () => {
    root.classList.add('pb-purchase-flow');
    try { sessionStorage.setItem('pb-purchase-flow', '1'); } catch (_) {}
    suppressNewsletter();
  };
  document.addEventListener('click', event => {
    if (event.target.closest('pb-card-shades, pb-compatible-activator, pb-cro-set, form[action*="/cart/add"], a[href$="/cart"]')) purchase();
  }, true);
  new MutationObserver(suppressNewsletter).observe(document.body, { childList:true, subtree:true });
  suppressNewsletter();

  if (customElements.get('pb-compatible-activator')) return;
  class CompatibleActivator extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const hu = this.dataset.language === 'hu';
      this.copy = hu ? {
        add:'Aktivátor a kosárba', busy:'Hozzáadás…', done:'Az oxidálószer a kosárba került.',
        error:'Ellenőrizd a kosarat, majd frissítsd az oldalt az újabb próbálkozás előtt.'
      } : {
        add:'Adaugă activatorul', busy:'Se adaugă…', done:'Oxidantul a fost adăugat în coș.',
        error:'Verifică produsele din coș și reîncarcă pagina înainte de a încerca din nou.'
      };
      this.select = this.querySelector('[data-activator-variant]');
      this.quantity = this.querySelector('[data-activator-quantity]');
      this.button = this.querySelector('[data-activator-add]');
      this.message = this.querySelector('[data-activator-message]');
      this.select.addEventListener('change', () => {
        const option = this.select.selectedOptions[0];
        this.quantity.min = option.dataset.min || '1';
        this.quantity.step = option.dataset.step || '1';
        this.quantity.max = option.dataset.max || '';
        this.quantity.value = this.quantity.min;
        this.message.textContent = '';
        this.update();
      });
      this.quantity.addEventListener('input', () => this.update());
      this.button.addEventListener('click', () => this.add());
      this.update();
    }
    update() {
      this.button.disabled = !!this.busy || !!this.locked || !this.select.value || !this.quantity.checkValidity() || !Number.isSafeInteger(Number(this.quantity.value)) || Number(this.quantity.value) < 1;
      this.button.textContent = this.busy ? this.copy.busy : this.copy.add;
      this.button.setAttribute('aria-busy', String(!!this.busy));
    }
    async add() {
      if (this.button.disabled) return;
      purchase();
      if (!window.PBCroCart) { this.message.textContent = this.copy.error; return; }
      this.busy = true;
      this.update();
      try {
        const result = await window.PBCroCart.add(new Map([[this.select.value, Number(this.quantity.value)]]), 'product');
        this.locked = !result?.complete;
        this.message.textContent = result?.complete ? this.copy.done : this.copy.error;
      } catch (_) {
        this.locked = true;
        this.message.textContent = this.copy.error;
      } finally { this.busy = false; this.update(); }
    }
  }
  customElements.define('pb-compatible-activator', CompatibleActivator);
})();

/* ===== CRO mobil 26 oct 2026 — vezi README din livrabil. Se scoate ștergând tot ce e sub această linie.
   Nu adaugă nimic în coș singur și nu schimbă logica pb-card-shades / pb-cro-set / PBCroCart: doar etichete,
   ce se vede și când, plus poziția butoanelor plutitoare. ===== */
(function () {
  'use strict';
  if (window.pbCroMobile20261026) return;
  window.pbCroMobile20261026 = true;
  const html = document.documentElement;
  const hu = (html.lang || '').split('-')[0] === 'hu';
  const T = hu ? {
    add: 'Kosárba', cod: 'Utánvéttel is fizethetsz',
    added: 'A kiválasztott árnyalatok a kosárba kerültek.', cart: 'Kosár megtekintése',
    oxidant: 'Kell hozzá oxidálószer is? Lent kiválaszthatod.'
  } : {
    add: 'Adaugă în coș', cod: 'Plătești la livrare (ramburs) sau cu cardul',
    added: 'Am pus în coș nuanțele alese.', cart: 'Vezi coșul',
    oxidant: 'Ai nevoie și de oxidant? Îl alegi mai jos.'
  };
  const rootUrl = () => (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const onReady = fn => document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', fn) : fn();

  /* ---- Reparația 1: ramburs în coșul lateral (pagina coșului și produsul îl au din Liquid) ---- */
  const codIcon = '<svg class="pb-cod-note__icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><rect x="2.5" y="6" width="19" height="12" rx="2"/><circle cx="12" cy="12" r="2.5"/><path d="M6 9.5v5M18 9.5v5"/></svg>';
  const codAllowed = () => {
    const country = (window.Shopify && Shopify.country) || '';
    return (country === 'RO' && !hu) || (country === 'HU' && hu);
  };
  const placeCodInDrawer = () => {
    const drawer = document.getElementById('CartDrawer');
    if (!drawer || !codAllowed()) return;
    // Locul corect: imediat sub rândul „Total” din rezumat; dacă rezumatul lipsește, deasupra butonului de finalizare.
    const total = drawer.querySelector('.pb-cro-cart-summary__total');
    const checkout = drawer.querySelector('.pb-cart-checkout-bar, [name="checkout"], a[href*="/checkout"]');
    const notes = drawer.querySelectorAll('[data-pb-cod]');
    let note = notes[0];
    for (let i = 1; i < notes.length; i++) notes[i].remove(); // niciodată două
    if (!total && !checkout) return;
    if (!note) {
      note = document.createElement('p');
      note.className = 'pb-cod-note pb-cod-note--cart';
      note.setAttribute('data-pb-cod', '');
      note.innerHTML = codIcon;
      const text = document.createElement('span');
      text.textContent = T.cod;
      note.appendChild(text);
    }
    if (total) { if (total.nextElementSibling !== note) total.insertAdjacentElement('afterend', note); }
    else if (checkout.parentNode && checkout.previousElementSibling !== note) checkout.parentNode.insertBefore(note, checkout);
  };
  let codFrame = 0;
  const scheduleCod = () => { if (!codFrame) codFrame = requestAnimationFrame(() => { codFrame = 0; placeCodInDrawer(); }); };
  onReady(() => {
    // Coșul lateral e re-randat de tema (sections API) la fiecare modificare, uneori înlocuind chiar elementul secțiunii:
    // un observer pus pe el s-ar pierde. Observăm tot body-ul (o singură verificare pe cadru, ieftină) și reverificăm și la evenimentele coșului.
    new MutationObserver(scheduleCod).observe(document.body, { childList: true, subtree: true });
    ['eurus:cart:items-changed', 'eurus:product:added', 'eurus:cart:drawer-opened'].forEach(name => document.addEventListener(name, () => { scheduleCod(); setTimeout(scheduleCod, 400); setTimeout(scheduleCod, 1200); }));
    scheduleCod();
  });

  /* ---- Reparația 2: vopsele pe pagina produsului ---- */
  const dyePage = () => !!document.querySelector('.product-info pb-compatible-activator, .product-info pb-card-shades[data-mode="pdp"]:not([data-picker-kind="size"])');
  const syncShade = el => {
    const count = el.drafts ? [...el.drafts.values()].filter(qty => qty > 0).length : 0;
    el.dataset.pbSel = count ? '1' : '0';
    // Un singur nume pentru butonul de cumpărare: „Adaugă în coș” (înainte: „Adaugă nuanțele și continuă” / „Continuă”).
    if (el.addButton && el.addButton.textContent !== T.add) el.addButton.textContent = T.add;
    if (count && el.stickyButton && el.stickyButton.textContent !== T.add) el.stickyButton.textContent = T.add;
  };
  onReady(() => {
    document.querySelectorAll('pb-card-shades[data-mode="pdp"]').forEach(el => {
      el.dataset.pbSel = '0';
      el.addEventListener('pb-cro:selection', () => syncShade(el));
    });
    if (window.customElements) customElements.whenDefined('pb-card-shades').then(() => requestAnimationFrame(() => {
      document.querySelectorAll('pb-card-shades[data-mode="pdp"]').forEach(syncShade);
    }));
  });

  let shadeAddPending = false;
  document.addEventListener('click', event => {
    if (event.target.closest('.pb-cro-card-shades__add, .pb-cro-shade-sticky__add')) shadeAddPending = true;
  }, true);

  const revealOxidant = fromShade => {
    if (!dyePage()) return;
    const first = !html.classList.contains('pb-dye-added');
    html.classList.add('pb-dye-added');
    const info = document.querySelector('.product-info');
    const activator = info && info.querySelector('pb-compatible-activator');
    const set = info && info.querySelector('pb-cro-set');
    if (first && !activator && set) {
      const details = set.closest('details');
      if (details) details.open = true;
    }
    if (!fromShade) return;
    // După ce PBCroCart și pb-card-shades își termină pașii (mesaj, derulare), confirmăm adăugarea și arătăm oxidantul.
    setTimeout(() => {
      const shade = document.querySelector('pb-card-shades[data-mode="pdp"]');
      if (shade && shade.message && shade.drafts && shade.drafts.size === 0 && !shade.uncertain) {
        shade.message.textContent = T.added + ' ';
        const link = document.createElement('a');
        link.href = rootUrl() + 'cart';
        link.textContent = T.cart;
        shade.message.appendChild(link);
        if (activator || set) shade.message.appendChild(document.createTextNode(' ' + T.oxidant));
      }
      const target = activator || set;
      if (target && target.getClientRects().length) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }, 0);
  };
  document.addEventListener('eurus:product:added', () => { revealOxidant(shadeAddPending); shadeAddPending = false; });
  document.addEventListener('eurus:cart:items-changed', () => { if (html.classList.contains('pb-purchase-flow')) revealOxidant(false); });

  /* ---- Reparația 3: bara fixă de jos nu acoperă Recompense / chat / „sus” ---- */
  const lifted = new Set();
  let wasOn = false;
  let dirty = true;
  const bars = () => [...document.querySelectorAll('.sticky_add_to_cart, .pb-cro-shade-sticky')];
  const visibleBar = () => bars().find(bar => {
    if (bar.hidden) return false;
    const style = getComputedStyle(bar);
    if (style.display === 'none' || style.visibility === 'hidden' || Number(style.opacity) === 0) return false;
    const rect = bar.getBoundingClientRect();
    return rect.height > 0 && rect.bottom >= window.innerHeight - 2 && rect.top < window.innerHeight;
  });
  const fixedAncestor = el => {
    for (let node = el; node && node !== document.body; node = node.parentElement) {
      if (getComputedStyle(node).position === 'fixed') return node;
    }
    return null;
  };
  const isFloating = (el, bar) => {
    if (!(el instanceof HTMLElement) || lifted.has(el)) return false;
    if (el === bar || el.contains(bar) || bar.contains(el)) return false;
    if (el.id === 'cookies-banner' || el.id === 'CartDrawer' || el.matches('[role="dialog"], .pb-cro-card-shades__panel, .pb-cro-card-shades__overlay, .sticky_add_to_cart, .pb-cro-shade-sticky')) return false;
    const style = getComputedStyle(el);
    if (style.position !== 'fixed' || style.display === 'none' || style.visibility === 'hidden') return false;
    const rect = el.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0 && rect.width < window.innerWidth * 0.6 && rect.height < 240 && rect.bottom > window.innerHeight - 160;
  };
  const shadeBarOwnsScrollTop = () => !!document.querySelector('body > .pb-cro-shade-sticky:not([hidden])');
  const collect = bar => {
    const found = new Set();
    document.querySelectorAll('[data-perkstack-trigger], .perkstack-launcher__trigger').forEach(el => { const f = fixedAncestor(el); if (f) found.add(f); });
    const skipScrollTop = shadeBarOwnsScrollTop(); // pb-cro-sticky.css mută deja butonul „sus” deasupra barei de nuanțe
    if (!skipScrollTop) document.querySelectorAll('#scroll_top, .scroll_top').forEach(el => { const f = fixedAncestor(el) || el; found.add(f); });
    for (const child of document.body.children) {
      if (isFloating(child, bar)) found.add(child);
      else for (const inner of child.children) if (isFloating(inner, bar)) found.add(inner);
    }
    if (skipScrollTop) found.forEach(el => { if (el.matches('#scroll_top, .scroll_top') || el.querySelector('#scroll_top, .scroll_top')) found.delete(el); });
    return found;
  };
  const release = () => {
    lifted.forEach(el => el.classList.remove('pb-lift'));
    lifted.clear();
    html.classList.remove('pb-sticky-on');
  };
  const update = () => {
    const bar = visibleBar();
    if (!bar) { if (wasOn) release(); wasOn = false; return; }
    html.style.setProperty('--pb-sticky-h', Math.ceil(bar.getBoundingClientRect().height) + 'px');
    html.classList.add('pb-sticky-on');
    if (!wasOn || dirty) collect(bar).forEach(el => { el.classList.add('pb-lift'); lifted.add(el); });
    wasOn = true;
    dirty = false;
  };
  let frame = 0;
  let settle = 0;
  const schedule = () => {
    if (!frame) frame = requestAnimationFrame(() => { frame = 0; update(); });
    clearTimeout(settle);
    settle = setTimeout(update, 650); // după animația de apariție/dispariție a barei (până la 500 ms)
  };
  onReady(() => {
    if (!document.querySelector('[data-pb-sticky-root], pb-card-shades[data-mode="pdp"]')) return;
    window.addEventListener('pb-cro-sticky-visibility', schedule);
    window.addEventListener('resize', () => { dirty = true; schedule(); });
    // Widgeturile (Recompense, chat) se încarcă târziu: le recunoaștem când apar.
    new MutationObserver(() => { dirty = true; schedule(); }).observe(document.body, { childList: true });
    schedule();
  });
})();

/* ===== CRO mobil 26 oct 2026 — adaugă din recomandări. Butonul „Adaugă” de pe cardurile din „S-ar putea să îți placă” (coșul lateral)
   folosește PBCroCart.add (același mecanism ca nuanțele/seturile): adaugă, reîmprospătează coșul lateral prin sections API și îl lasă deschis.
   Se scoate ștergând tot ce e sub această linie. ===== */
(function () {
  'use strict';
  if (window.pbMiniAdd20261026) return;
  window.pbMiniAdd20261026 = true;
  document.addEventListener('click', async event => {
    const btn = event.target.closest('[data-pb-mini-add]');
    if (!btn) return;
    event.preventDefault();
    event.stopPropagation();
    if (btn.disabled) return;
    document.documentElement.classList.add('pb-purchase-flow');
    const set = (text, state) => { btn.textContent = text; btn.dataset.state = state; };
    if (!window.PBCroCart) { set(btn.dataset.error, 'error'); return; }
    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');
    set(btn.dataset.busy, 'busy');
    let ok = false;
    try {
      const result = await window.PBCroCart.add(new Map([[btn.dataset.variantId, Number(btn.dataset.quantity) || 1]]), 'cart-recommendation', { openCart: false });
      ok = !!(result && result.complete);
    } catch (_) {}
    btn.removeAttribute('aria-busy');
    // După reîmprospătarea coșului cardul poate fi înlocuit; dacă mai există, arătăm rezultatul scurt.
    if (!btn.isConnected) return;
    set(ok ? btn.dataset.done : btn.dataset.error, ok ? 'done' : 'error');
    setTimeout(() => { if (btn.isConnected) { btn.disabled = false; set(btn.dataset.label, 'idle'); } }, ok ? 1800 : 2500);
  }, true);
})();

/* ===== CRO mobil 26 oct 2026 — reparații după test (7). Se scoate ștergând tot ce e sub această linie. ===== */
(function () {
  'use strict';
  if (window.pbCroRepairs7) return;
  window.pbCroRepairs7 = true;
  const html = document.documentElement;
  const hu = (html.lang || '').split('-')[0] === 'hu';
  const L = hu ? { busy: 'Hozzáadás…', oxQ: 'Kell hozzá oxidálószer is?', oxGo: 'Oxidálószer választása', oxSentence: 'Kell hozzá oxidálószer is? Lent kiválaszthatod.' }
               : { busy: 'Se adaugă…', oxQ: 'Ai nevoie și de oxidant?', oxGo: 'Alege oxidantul', oxSentence: 'Ai nevoie și de oxidant? Îl alegi mai jos.' };
  const BTN = '.pb-cro-card-shades__add, .pb-cro-shade-sticky__add';

  /* 7.2 Butonul arată „Se adaugă…” cât lucrează coșul (PBCroCart trimite pb-cro:cart-busy); dubla apăsare e deja blocată de pb-card-shades (busy + disabled). */
  const relabeled = new Map();
  let lastShadeClick = 0;
  let addFromShade = false;
  document.addEventListener('click', event => { if (event.target.closest(BTN)) lastShadeClick = Date.now(); }, true);
  document.addEventListener('pb-cro:cart-busy', event => {
    const busy = !!(event.detail && event.detail.busy);
    if (busy) {
      addFromShade = Date.now() - lastShadeClick < 2000; // adăugare pornită din butonul nuanțelor (nu din oxidant)
      document.querySelectorAll(BTN).forEach(btn => {
        if (relabeled.has(btn) || !btn.getClientRects().length) return;
        relabeled.set(btn, btn.textContent);
        btn.textContent = L.busy;
        btn.setAttribute('aria-busy', 'true');
      });
    } else {
      setTimeout(() => { addFromShade = false; }, 100);
      setTimeout(() => {
        relabeled.forEach((text, btn) => {
          btn.removeAttribute('aria-busy');
          if (btn.textContent === L.busy) btn.textContent = text; // dacă pb-card-shades a pus între timp alt text, îl lăsăm
        });
        relabeled.clear();
      }, 0);
    }
  });

  /* 7.3 După nuanțe: mesajul se împarte în două rânduri; coșul lateral se deschide; oxidantul apare și ca sugestie în coș. */
  const mini = () => (window.Alpine && Alpine.store && Alpine.store('xMiniCart')) || null;
  const fixMessage = () => {
    const message = document.querySelector('pb-card-shades[data-mode="pdp"] .pb-cro-card-shades__message');
    if (!message || message.querySelector('.pb-cro-msg-oxidant')) return;
    const text = message.textContent || '';
    if (!text.includes(L.oxSentence)) return;
    // „Am pus în coș nuanțele alese. Vezi coșul.” + rând nou cu întrebarea despre oxidant
    const walker = document.createTreeWalker(message, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) {
      if (node.nodeValue.includes(L.oxSentence)) {
        node.nodeValue = node.nodeValue.replace(L.oxSentence, '').replace(/\s+$/, '');
        break;
      }
    }
    const tail = document.createElement('span');
    tail.className = 'pb-cro-msg-oxidant';
    tail.textContent = L.oxSentence;
    // punct după linkul „Vezi coșul”, ca să nu pară o singură frază
    const link = message.querySelector('a');
    if (link && !/[.!?]$/.test(link.textContent)) link.insertAdjacentText('afterend', '.');
    message.appendChild(tail);
  };
  const addHint = () => {
    const footer = document.querySelector('#update-cart .footer-cart-drawer-mobile');
    if (!footer || footer.querySelector('.pb-oxidant-hint')) return;
    const target = document.querySelector('.product-info pb-compatible-activator, .product-info pb-cro-set');
    if (!target) return;
    const box = document.createElement('div');
    box.className = 'pb-oxidant-hint';
    const label = document.createElement('span');
    label.textContent = L.oxQ;
    const go = document.createElement('button');
    go.type = 'button';
    go.textContent = L.oxGo;
    go.addEventListener('click', () => {
      const store = mini();
      if (store && store.hideCart) store.hideCart();
      setTimeout(() => target.scrollIntoView({ behavior: 'smooth', block: 'center' }), 150);
    });
    box.append(label, go);
    footer.insertBefore(box, footer.firstChild);
  };
  document.addEventListener('eurus:product:added', () => {
    // doar după adăugarea nuanțelor de pe pagina produsului (nu după oxidant)
    if (!addFromShade || !document.querySelector('pb-card-shades[data-mode="pdp"]')) return;
    setTimeout(() => {
      fixMessage();
      const store = mini();
      if (!store || !document.querySelector('.product-info pb-compatible-activator, .product-info pb-cro-set')) return;
      if (!store.open && store.openCart) store.openCart();
      setTimeout(addHint, 350);
    }, 30);
  });

  /* 7.4 „+” peste stoc: tema pune mesajul în linia produsului (LineItemError-…); ne asigurăm că ajunge în ecran. */
  new MutationObserver(records => {
    for (const record of records) {
      const el = record.target;
      if (el.classList && el.classList.contains('cart-item__error') && !el.classList.contains('hidden') && (el.textContent || '').trim()) {
        el.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
        return;
      }
    }
  }).observe(document.body, { subtree: true, attributes: true, attributeFilter: ['class'] });
})();
